import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaLink } from 'react-icons/fa';

function SocialIcons() {
    const elements = [
        {
            url: 'https://www.facebook.com/smetalbauru',
            icon: <FaFacebookF />,
            description: 'Logo do Facebook'
        }, 
        {
            url: 'https://www.instagram.com/metalbauru',
            icon: <FaInstagram />,
            description: 'Logo do Instagram'
        },
    ];

    return (
        <Row>
            {elements.map((element, index) => (
                <Col key={index} className='text-center social-icons'>
                    <a href={element.url} target='_blank' rel='noreferrer' aria-label={elements.description}>
                        {element.icon}
                    </a>
                </Col>
            ))}
        </Row>
    );
}

export default SocialIcons;
